import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { BOM_USERS_API } from "../apiRoutes";

const mutateTransferBomUser = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${BOM_USERS_API}/transfer`, data);
};

const useTransferBomUserMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateTransferBomUser,
    ...queryParams,
  });

export default useTransferBomUserMutation;
